module.exports = __webpack_public_path__ + "static/media/16c.f851097e.jpeg";